import { DataBean } from "../DataBean";

export class IndirectCost extends DataBean {

    public async getIndirectCostCatalog(idIndirectCost: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIndirectCostCatalog_Number", [idIndirectCost]);
    }

}
